import { useState } from "react";
import { Wrench, Package, ShoppingCart, Building, ClipboardList } from "lucide-react";
import MechanicsTab from "./MechanicsTab";
import InventoryTab from "./InventoryTab";
import SuppliersTab from "./SuppliersTab";
import PurchasingTab from "./PurchasingTab";
import RepairsTab from "./RepairsTab";

export default function MaintenanceTab({ drivers = [], user = null }) {
  const [activeView, setActiveView] = useState("repairs"); // repairs, mechanics, inventory, purchasing, suppliers

  const subTabs = [
    { id: "repairs", label: "Repairs", shortLabel: "Repairs", icon: ClipboardList },
    { id: "mechanics", label: "Mechanics", shortLabel: "Mechs", icon: Wrench },
    { id: "inventory", label: "Inventory", shortLabel: "Stock", icon: Package },
    { id: "purchasing", label: "Purchasing", shortLabel: "Purchase", icon: ShoppingCart },
    { id: "suppliers", label: "Suppliers", shortLabel: "Suppliers", icon: Building },
  ];

  return (
    <div className="space-y-4" data-testid="maintenance-tab">
      {/* Sub-tabs Navigation */}
      <div className="flex flex-wrap gap-2 sm:gap-0">
        {subTabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveView(tab.id)}
              className={`px-3 sm:px-4 h-9 sm:h-10 font-heading font-bold text-xs sm:text-sm uppercase transition-colors flex items-center gap-1 sm:gap-2 ${
                activeView === tab.id
                  ? "bg-primary text-white"
                  : "bg-[#161920] text-white/60 hover:text-white hover:bg-white/5 border border-white/10"
              } ${activeView === tab.id ? "" : "sm:border-l-0 first:sm:border-l"}`}
              data-testid={`maintenance-tab-${tab.id}`}
            >
              <Icon className="w-4 h-4" strokeWidth={2} />
              <span className="hidden sm:inline">{tab.label}</span>
              <span className="sm:hidden">{tab.shortLabel}</span>
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      {activeView === "repairs" && (
        <RepairsTab drivers={drivers} user={user} />
      )}

      {activeView === "mechanics" && (
        <MechanicsTab />
      )}

      {activeView === "inventory" && (
        <InventoryTab user={user} />
      )}

      {activeView === "purchasing" && (
        <PurchasingTab user={user} />
      )}

      {activeView === "suppliers" && (
        <SuppliersTab />
      )}
    </div>
  );
}
